import { render, staticRenderFns } from "./ModalDocumentsList.vue?vue&type=template&id=6ea25c38&scoped=true&"
import script from "./ModalDocumentsList.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./ModalDocumentsList.vue?vue&type=style&index=0&id=6ea25c38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea25c38",
  null
  
)

export default component.exports